import React from 'react';
import { Box, CssBaseline } from '@mui/material';
import Sidebar from './Sidebar';

const MainLayout = ({ children }) => {
  return (
    <Box className="main-layout">
      <CssBaseline />
      <Sidebar />
      <Box className="main-content">
        {children}
      </Box>
    </Box>
  );
};

export default MainLayout;
